<ng-container *ngIf="specialPrograms$ | async as specialPrograms">
  <ng-container *ngIf="specialPrograms?.length > 0">
    <div class="special-program-select">
      <ng-select
        [searchable]="false"
        [clearable]="false"
        placeholder="Special Program"
        (change)="selectSpecialProgram($event)"
        [ngModel]="selectedSpecialProgramCode"
        (open)="pauseCarouselAutoplay()"
        (close)="resumeCarouselAutoplay()"
      >
        <ng-option
          *ngFor="let specialProgram of specialPrograms"
          [value]="specialProgram.code">
          <div class="sp-item">
            <span>{{ specialProgram.name }}</span>
            <img class="sp-selected-icon" src="../../../../assets/icons/check_orange_24.svg">
          </div>
        </ng-option>
      </ng-select>
      <cx-icon
        class="special-program-arrow"
        [type]="iconType.CARET_RIGHT"
        aria-hidden="true">
      </cx-icon>
    </div>
  </ng-container>
</ng-container>
